import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import api from '../api.js';
import LoadingState from '../components/LoadingState.jsx';
import PremiumCrown from '../components/PremiumCrown.jsx';

export default function Friends() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('friends');
  const [friends, setFriends] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    if (!user?.uid) return;
    setLoading(true);
    Promise.all([
      api.getFriends(user.uid).then((r) => setFriends(r?.friends || r || [])).catch(() => {}),
      api
        .getFriendRequests(user.uid)
        .then((r) => setRequests(r?.requests || r || []))
        .catch(() => {}),
    ]).finally(() => setLoading(false));
  };

  useEffect(load, [user?.uid]);

  const accept = async (fid) => {
    await api.acceptFriendRequest(user.uid, fid).catch(() => {});
    load();
  };
  const decline = async (fid) => {
    await api.declineFriendRequest(user.uid, fid).catch(() => {});
    load();
  };

  return (
    <div className="screen">
      <div className="screen-header">
        <h1>Social</h1>
        <button className="chip" onClick={() => navigate('/friends/add')}>
          + Add
        </button>
      </div>

      <div className="tab-switch">
        <button
          className={tab === 'friends' ? 'active' : ''}
          onClick={() => setTab('friends')}
        >
          Friends ({friends.length})
        </button>
        <button
          className={tab === 'requests' ? 'active' : ''}
          onClick={() => setTab('requests')}
        >
          Requests ({requests.length})
        </button>
      </div>

      {tab === 'friends' && (
        <LoadingState
          loading={loading}
          empty={friends.length === 0}
          emptyIcon="👥"
          emptyTitle="No friends yet"
          emptyHint="Add a friend to track scores together"
        >
          <div className="friends-grid">
            {friends.map((f) => (
              <div className="friend-row" key={f.id || f.userId}>
                <div className="avatar">{f.avatar || f.displayName?.[0]?.toUpperCase() || '?'}</div>
                <div className="grow">
                  <div className="name">
                    {f.displayName || 'Unknown'}
                    <PremiumCrown tier={f.tier} />
                  </div>
                  <div className="sub">
                    {f.city || '—'} · {f.gamesPlayed || 0} games
                  </div>
                </div>
              </div>
            ))}
          </div>
        </LoadingState>
      )}

      {tab === 'requests' && (
        <LoadingState
          loading={loading}
          empty={requests.length === 0}
          emptyIcon="📭"
          emptyTitle="No requests"
        >
          <div className="friends-grid">
            {requests.map((r) => (
              <div className="friend-row" key={r.id || r.userId}>
                <div className="avatar">{r.displayName?.[0]?.toUpperCase() || '?'}</div>
                <div className="grow">
                  <div className="name">{r.displayName || 'Unknown'}</div>
                  <div className="sub">wants to be friends</div>
                </div>
                <button
                  className="btn btn-primary"
                  style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}
                  onClick={() => accept(r.userId || r.id)}
                >
                  Accept
                </button>
                <button
                  className="btn btn-ghost"
                  style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}
                  onClick={() => decline(r.userId || r.id)}
                >
                  Decline
                </button>
              </div>
            ))}
          </div>
        </LoadingState>
      )}
    </div>
  );
}
